import { IGovernamentalStructureReponse } from "models/response/governamental-strutucture-response";

export interface OrganizationalStructureDetailsState {
  organizationalStructureDetails: IGovernamentalStructureReponse | null;
  loading: boolean;
}

export const ACTION_TYPES = {
  setOrganizationalStructureDetails: 'setOrganizationalStructureDetails',
  setLoading: 'setLoading',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface OrganizationalStructureDetailsAction {
  type: ActionType;
  payload: any;
}

export const OrganizationalStructureDetailsReducer = (
  state: OrganizationalStructureDetailsState,
  action: OrganizationalStructureDetailsAction
): OrganizationalStructureDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setOrganizationalStructureDetails:
      return {
        ...state,
        organizationalStructureDetails: action.payload,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};